import {
  ChangeDetectorRef,
  Component,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SharedComponentsModule } from '@wilson/shared-components';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'wilson-qualification-shared-user-renderer',
  template: `
    <span class="d-flex align-items-center cursor-pointer">
      <wilson-user-avatar
        [s3Urn]="profileImage"
        [fallbackImage]="fallbackImage"
        class="avatar"
      ></wilson-user-avatar>
      {{ cellValue }}
    </span>
  `,
  imports: [SharedComponentsModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .avatar {
        margin-right: 4px;
        width: 14px;
        height: 14px;
      }
      .cursor-pointer {
        cursor: pointer;
      }
    `,
  ],
})
export class QualificationSharedUserRendererComponent
  implements AgRendererComponent
{
  private cdRef = inject(ChangeDetectorRef);

  public cellValue!: string;
  public fallbackImage = 'assets/img/profile/profile-img-placeholder-dark.svg';
  public profileImage: string | null | undefined;
  private user!: {
    firstName: string;
    lastName: string;
    profileImageUrl: string;
  };

  async agInit(params: ICellRendererParams): Promise<void> {
    this.user = params.data?.user;

    this.profileImage = this.user?.profileImageUrl;

    this.cellValue = this.user
      ? `${this.user.firstName} ${this.user.lastName}`
      : 'Unknown User';
    this.cdRef.detectChanges();
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }
}
